export class ReferralSource {
  public static ANDROID = "android";
  public static IOS = "ios";
}
